import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import MobileConfirmedSlot from './MobileConfirmedSlot'

export default function MobileSlotPage ({ box, slot, onCancel, slotStatus }) {
  return (
    <>
      <PublicSiderXS />
      <MobileConfirmedSlot box={box} slot={slot} onCancel={onCancel} slotStatus={slotStatus} />
    </>
  )
}
